<template>
  <div class="impact-hints-edition">
    <div v-for="(hint, idx) in hintsCopy" :key="idx" class="impact-hints-edition-row v-centerer">
      <Icon @click.native="removeHint(idx)">{{ deleteMedium }}</Icon>
      <InputNumber
        v-model="hint.impact"
        :legend="`${$t('message.ENTER_IMPACT_VALUE')}${$t('message.TWO_DOTS')}`"
        class="row-value v-centerer"
        set-dashed-border
        :min="0"
        :max="3"
        refresh-after-input
        @input="$emit('hintsUpdated', hintsCopy)"
      />
      <EditableLabel
        v-model="hint.text"
        :legend="`${$t('message.ENTER_IMPACT_HINT')}${$t('message.TWO_DOTS')}`"
        use-textarea
        class="row-text v-centerer"
        @input="$emit('hintsUpdated', hintsCopy)"
      />
      <div class="vertical-rectangle" />
    </div>

    <button class="add-button" @click="hintsCopy.push({ impact: 0, text: '' })">
      <Icon>{{ addCircleMedium }}</Icon>
      <span>{{ $t('message.ADD_IMPACT_HINT') }}</span>
    </button>

    <ImpactSlider
      v-model="previewImpact"
      class="preview"
      :legend="`${$t('message.IMPACT_HINTS_PREVIEW')}${$t('message.TWO_DOTS')}`"
      :hints="hintsCopy"
    />
  </div>
</template>

<script>
/**
 * Components to edit the hints of an impact slider
 *
 * @vue-prop {Object} hints - Hints to customize : [{ impact: 0, text: 'hint' }, { ... }]
 *
 * @vue-event {Object} hintsUpdated - hints value has been updated
 */

import { cloneDeep } from 'lodash';
// Components
import EditableLabel from '@/components/editable-label.vue';
import Icon from '@/components/icon.vue';
import ImpactSlider from '@/components/impact-slider.vue';
import InputNumber from '@/components/input-number.vue';
// Utils/Assets
import { addCircleMedium, deleteMedium } from '@/assets/icons';

export default {

  name: 'ImpactHintsEdition',

  components: {
    EditableLabel,
    Icon,
    ImpactSlider,
    InputNumber,
  },

  props: {
    hints: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      addCircleMedium,
      deleteMedium,
      // Use a copy to prevent delay between change and dom update
      hintsCopy: [],
      previewImpact: 0,
    };
  },

  watch: {
    hints: {
      deep: true,
      handler(newValue) {
        this.hintsCopy = cloneDeep(newValue || []);
      },
    },
  },

  created() {
    this.hintsCopy = cloneDeep(this.hints || []);
  },

  methods: {
    /** Remove hint at index */
    removeHint(index) {
      this.hintsCopy.splice(index, 1);
      this.$emit('hintsUpdated', this.hintsCopy);
    },
    /** Update one of the 5W1H hint */
    hintUpdated(key, hint) {
      const val = Object.assign({}, this.hints);
      val[key] = hint;
      this.$emit('hintsUpdated', this.hintsCopy);
    },
  },

};
</script>

<style lang="scss">
.impact-hints-edition {

  .impact-hints-edition-row {
    flex-wrap: wrap;
    position: relative;
    padding-left: 0.8em;
    margin-top: 0.5em;

    .icon {
      width: 1.4em;
      height: auto;
      flex-grow: 0;
      margin-right: 0.4em;
      cursor: pointer;
    }
    .row-value {
      flex: 1;
      flex-wrap: nowrap;

      .legend {
        flex: 0;
        white-space: nowrap;
      }

      input {
        flex: 1;
        max-width: 3em;
        margin-left: 0.3em;
      }
    }
    .row-text.editable-label {
      flex: 1;
      flex-wrap: nowrap;

      .legend {
        flex: 0;
        white-space: nowrap;

        &.legend--bottom-margin {
          margin-bottom: 0px;
        }
      }
      textarea {
        flex: 1;
        min-width: 10em;
      }
    }
    .vertical-rectangle {
      position: absolute;
      top: 0.2em;
      bottom: 0.4em;
      left: 0px;
      width: 3px;
      background: #aaa;
    }
  }

  .preview {
    margin-top: 0.5em;
    margin-bottom: 5em;
    border: 1px dashed;
    padding: 0.2em 0.5em 2em 0.5em;
    max-width: 350px;

    .vue-slider {
      flex: 1;
      margin: 0px 1em;
    }
    .value {
      flex: 0;
    }
  }
}
</style>
